import { render } from "./FindThePlanet.vue?vue&type=template&id=5ab29126&scoped=true"
import script from "./FindThePlanet.vue?vue&type=script&lang=js"
export * from "./FindThePlanet.vue?vue&type=script&lang=js"

import "./FindThePlanet.vue?vue&type=style&index=0&id=5ab29126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab29126"]])

export default __exports__